import { TLanguageCode } from '../../../../store/models/types';
import { AppThunk } from '../../../../store/types';
import { Navigator } from '../../../../effects/navigator';
import { EventsRouter } from '../../../../../common/events/eventsRouter';
import { Events } from '../../../../../common/events/types';
import { ELanguageStatus } from '../../../../store/general/types';
import { setAuthUserAction } from '../../../../store/general/actions';
import { updateUserLanguages } from '../../../../effects/updateUserLanguages';
import { updateUserGroups } from '../../../../effects/updateUserGroups';
import { UserRoleEffects } from '../../../../effects/userRoleEffects';
import { getAuthUser } from '../../../../store/general/selectors';
import { AuthManager } from '../../../../../common/utils/auth-manager';
import { getUserRoles } from '../../../../store/models/selectors';
import { LanguageRest } from '../../../../../common/rest/userLanguage/languageRest';

export class InstallSelectLangsEvents {

  public static onSave(nativeLangCode: TLanguageCode, targetLangCode: TLanguageCode, roles: number[]): AppThunk {
    return async(
      dispatch,
      getState
    ): Promise<any> => {
      EventsRouter.trackEvent(Events.GET_STARTED_CLICKED);
      try {
        await LanguageRest.updateUserLanguages([
          { code: nativeLangCode, status: ELanguageStatus.KNOW },
          { code: targetLangCode, status: ELanguageStatus.TO_LEARN }
        ]);
        await Promise.all([
          dispatch(updateUserLanguages()),
          dispatch(updateUserGroups(true)),
        ]);
        await UserRoleEffects.saveUserRoles(roles);

        if (roles && roles.length) {
          const userRoles = getUserRoles(getState());
          roles.forEach(roleId => {
            const role = userRoles.find(item => item.id === roleId)?.name;
            if (role) EventsRouter.trackEvent(Events.USER_ROLE_SELECTED, undefined, { role });
          });
        }
      } catch(e) {
        console.error(e)
      }

      const returnUrl = Navigator.popReturnUrlAfterSelectLangs();
      if (returnUrl) {
        Navigator.openUrl(returnUrl);
      } else {
        Navigator.openCall();
      }
    }
  }

  public static onLoad(): AppThunk {
    return async(
      dispatch,
      getState
    ): Promise<any> => {
      const authUser = getAuthUser(getState());
      if (!authUser) {
        const result = await AuthManager.autoLogin();
        if (result && result.authUser) {
          dispatch(setAuthUserAction(result.authUser));
        }
      }
      dispatch(updateUserLanguages(false));
      UserRoleEffects.loadUserRoles();
    }
  }

}
